import { BaseModel } from './BaseModel';
import { Device } from './Device';
import { Ration } from './Ration';

export class Airsacculitis extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.percentage = data?.percentage ?? null;
    this.contaminatedBirds = isApi ? data?.contaminatedBirds : data.contaminatedBirds;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
export class Enthalpy {
  constructor(data = null) {
    if (!data || typeof data !== 'object') {
      this.value = null;
      this.status = 'no-data';
      this.comfort = 'no-data';
      return;
    }

    this.value = data.value ?? null;
    this.status = data.status ?? 'no-data';
    this.comfort = data.comfort ?? this.status ?? 'no-data';
  }
}

export class S0 extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';
    const normalized = Array.isArray(data) ? data[0] : data;

    if (!normalized || typeof normalized !== 'object') {
      this.enthalpy = new Enthalpy();
      return;
    }

    this.timestamp = normalized.timestamp ? new Date(normalized.timestamp) : null;

    this.age = normalized.age ?? null;
    this.type = normalized.type ?? null;

    this.bedTemperature = isApi ? normalized.bed_temperature : normalized.bedTemperature;
    this.environmentTemperature = isApi
      ? normalized.environment_temperature
      : normalized.environmentTemperature;
    this.waterTemperature = isApi ? normalized.water_temperature : normalized.waterTemperature;
    this.humidity = normalized.humidity ?? null;

    this.device = normalized.device ? Device.create(normalized.device, source) : null;

    this.enthalpy = new Enthalpy(normalized.enthalpy);
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
export class D0 extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';
    this.timestamp = data?.timestamp ? new Date(data.timestamp) : null;

    this.age = data?.age ?? null;
    this.type = data?.type ?? null;

    this.co2 = data?.co2 ?? null;

    this.internHumidity = isApi ? data?.intern_humidity : data?.internHumidity;

    this.internTemperature = isApi ? data?.intern_temperature : data?.internTemperature;

    this.device = data?.device ? Device.create(data.device, source) : null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class E0 extends BaseModel {
  hydrate(data) {
    this.timestamp = data?.timestamp ? new Date(data.timestamp) : null;

    this.age = data?.age ?? null;
    this.type = data?.type ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class Feedmetrics extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.availableWeight = isApi ? data.available_weight : data.availableWeight ?? null;

    this.freeWeight = isApi ? data.free_weight : data.freeWeight ?? null;

    const lastReceived = isApi ? data.last_received_time : data.lastReceivedTime;

    this.lastReceivedTime = lastReceived ? new Date(lastReceived) : null;

    this.status = data.status ?? null;

    const currentRation = isApi ? data.current_ration : data.currentRation;
    this.currentRation = currentRation ? Ration.create(currentRation, source) : null;

    this.totalOccupation = isApi ? data.total_occupation : data.totalOccupation ?? null;

    this.invoiceDeliveries = isApi ? data.invoice_deliveries : data.invoiceDeliveries ?? null;

    this.age = data.age ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class RationEndPrediction extends BaseModel {
  hydrate(data) {
    this.timestamp = data?.timestamp ? new Date(data.timestamp) : null;

    this.amount = data?.amount ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
